import { BREAKPOINTS, Button, DataTable, Modal, Stack, colors, rem, useLang } from "@manulife/mux";
import { Cross } from '@manulife/mux-cds-icons';
import useWindowSize from "../../customHooks/useWindowSize";
import NumberConstants from "../../assets/appStyledComponents/numberConstant.json";
import resultLabels from '../../assets/resultLabels.json';
import { useEffect, useMemo, useState } from "react";
import { formatAmount } from "../../services/helpers/commonHelpers";

function RtgTableVersionModal({ isModalOpen, closeModal, chartData }) {
    const { num2, num40, num960, num60 } = NumberConstants;
    const selectedLang = useLang();
    const [tableData, setTableData] = useState([]);
    const { width: windowWidth } = useWindowSize();

    const column = useMemo(() => [
        { header: resultLabels.age[`${selectedLang}`].label, accessorKey: "age" },
        { header: resultLabels.t10[`${selectedLang}`].label, accessorKey: "term10" },
        { header: resultLabels.t20[`${selectedLang}`].label, accessorKey: "term20" },
        { header: resultLabels.t65[`${selectedLang}`].label, accessorKey: "term65" }
    ], [selectedLang]);

    useEffect(() => {
        if (chartData) {
            let data = [];
            let dataMap = { age: [], term10: [], term20: [], term65: [] };
            chartData.vector.forEach((ele) => {
                if (ele.coverageProduct === "Term10") {
                    dataMap.term10 = ele.value;
                } else if (ele.coverageProduct === "Term20") {
                    dataMap.term20 = ele.value;
                } else if (ele.coverageProduct === "Term65") {
                    dataMap.term65 = ele.value;
                } else if (ele.type === "Age") {
                    dataMap.age = ele.value;
                }
            });
            dataMap.age.forEach((ele, index) => {
                let rowData = {};
                rowData.ID = index;
                rowData.age = ele;
                rowData.term10 = formatAmount((dataMap.term10[index]).toFixed(num2), selectedLang);
                rowData.term20 = formatAmount((dataMap.term20[index]).toFixed(num2), selectedLang);
                rowData.term65 = formatAmount((dataMap.term65[index]).toFixed(num2), selectedLang);
                data.push(rowData);
            });
            setTableData(data);
        }
    }, [chartData, num2, selectedLang]);

    let modalStyle = {
        width: rem(num960),
        padding: 0
    };

    if (windowWidth <= BREAKPOINTS.TABLET_LANDSCAPE) {
        modalStyle = {
            ...modalStyle,
            width: "95vw",
            maxHeight: "95vh"
        };
    }

    return (
        <Modal isOpen={isModalOpen} showCloseButton={false} shouldCloseOnBackdropClick={false} customStyle={{ modalStyle }}>
            <Stack direction="row" align="center" justify="flex-end">
                <Button
                    variant={Button.VARIANT.TERTIARY_BACK}
                    icon={<Cross fontSize={rem(20)} color={colors.super_dark_navy} style={{ marginRight: 0 }} />}
                    customStyle={{
                        buttonStyle: {
                            padding: 0,
                            width: rem(num40),
                            height: rem(num40)
                        }
                    }}
                    aria-label="closeModal"
                    onClick={closeModal}
                >{''}</Button>
            </Stack>
            <Stack align="flex-start" gap={rem(num40)} style={{ padding: `${rem(0)} ${rem(num40)} ${rem(num60)}` }}>
                <DataTable
                    title={resultLabels.chartTitle[`${selectedLang}`]}
                    columns={column}
                    data={tableData}
                />
            </Stack>
        </Modal>
    );
}

export default RtgTableVersionModal;